import { render, staticRenderFns } from "./CopyCategoryCollapse.vue?vue&type=template&id=33c705c8&scoped=true"
import script from "./CopyCategoryCollapse.vue?vue&type=script&lang=js"
export * from "./CopyCategoryCollapse.vue?vue&type=script&lang=js"
import style0 from "./CopyCategoryCollapse.vue?vue&type=style&index=0&id=33c705c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c705c8",
  null
  
)

export default component.exports